import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';

const CheckNetworkConnectivity: ContainerComponent = ({ children }) => {
    return <>{children}</>;
};

export default CheckNetworkConnectivity;
